import { notEmpty } from '@festina-life/core'

import { isSimpleValueSetupField } from '../../../types/templateModel'
import type { SpecialCasedSubTemplatedValueSetup } from '../types'

export const getCalcStepPriority = (
  data: SpecialCasedSubTemplatedValueSetup,
): number => {
  const variant = data.field.value?.variants.find(
    (variant) => variant.subTemplateIdentifier === data.subTemplateIdentifier,
  )
  const priorityField = variant?.fields.find(
    (field) => field.name === 'priority',
  )

  const prioritySource =
    priorityField && isSimpleValueSetupField(priorityField)
      ? priorityField.value?.defaultValue?.expression?.fplusSource
      : undefined

  const priorityValue = notEmpty(prioritySource)
    ? parseInt(prioritySource)
    : Number.MAX_VALUE

  return Number.isNaN(priorityValue) ? Number.MAX_VALUE : priorityValue
}
